import { z } from "zod";

export const channelRateLimitsGetSchema = z.partialRecord(
  z.enum([
    "android_push",
    "content_cards",
    "control",
    "deprecated",
    "email",
    "ios_push",
    "kindle_push",
    "line",
    "push",
    "sms",
    "trigger_in_app_message",
    "web_push",
    "webhook",
    "whats_app",
  ]),
  z.int().optional()
);
